// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__1fd4H","title":"ClientReferral_title__-kk_W","itemText":"ClientReferral_itemText__j7RME"};